import { render, staticRenderFns } from "./claimsCaseManage.vue?vue&type=template&id=4708abb3&scoped=true&"
import script from "./claimsCaseManage.vue?vue&type=script&lang=js&"
export * from "./claimsCaseManage.vue?vue&type=script&lang=js&"
import style0 from "./claimsCaseManage.vue?vue&type=style&index=0&id=4708abb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4708abb3",
  null
  
)

export default component.exports